import React from "react";
import { Tag, Typography } from "antd";
import { SkillEvidence } from "../../../../Service/application.insight.service";

type SkillStatus = "matches" | "partial_match" | "not_a_match";

function statusLabel(status: SkillStatus): string {
  if (status === "matches") return "Matches";
  if (status === "partial_match") return "Partial Match";
  return "Not a Match";
}

function statusColor(status: SkillStatus): string {
  if (status === "matches") return "success";
  if (status === "partial_match") return "warning";
  return "error";
}

const SkillCard = ({ skill }: { skill: SkillEvidence }) => (
  <div className="aic-skill-card">
    <div className="aic-skill-card-header">
      <Typography.Text strong>{skill.skillName}</Typography.Text>
      <Tag color={statusColor(skill.status)}>{statusLabel(skill.status)}</Tag>
    </div>
    <Typography.Text type="secondary" style={{ fontStyle: "italic" }}>
      "{skill.evidence}"
    </Typography.Text>
  </div>
);

interface SkillMatchBlockProps {
  mustHave: SkillEvidence[];
  niceToHave: SkillEvidence[];
}

const SkillMatchBlock: React.FC<SkillMatchBlockProps> = ({ mustHave, niceToHave }) => (
  <div className="aic-skill-match">
    {mustHave.length > 0 && (
      <div>
        <div className="aic-header-title">
          <span
            className="material-symbols-outlined"
            data-icon="inbox_text_asterisk"
            style={{ color: "#000000", fontSize: "16px" }}
          >
            inbox_text_asterisk
          </span>
          <Typography.Text strong>
            Must Have ({mustHave.length.toString().padStart(2, "0")})
          </Typography.Text>
        </div>
        <div className="skill-card-wrapper">
          {mustHave.map((s, i) => (
            <SkillCard skill={s} key={i} />
          ))}
        </div>
      </div>
    )}
    {niceToHave.length > 0 && (
      <div>
        <div className="aic-header-title">
          <span
            className="material-symbols-outlined"
            data-icon="star"
            style={{ color: "#000000", fontSize: "16px" }}
          >
            star
          </span>
          <Typography.Text strong>
            NICE TO HAVE ({niceToHave.length.toString().padStart(2, "0")})
          </Typography.Text>
        </div>
        <div className="skill-card-wrapper">
          {niceToHave.map((s, i) => (
            <SkillCard skill={s} key={i} />
          ))}
        </div>
      </div>
    )}
  </div>
);

export default SkillMatchBlock;
